import _objectSpread from "/root/ONLINE_SERVICE/other/ferry/task_workspace/baidu/map-ai-native/feed-h5/node_modules/.pnpm/@babel+runtime@7.23.2/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import { mapMutations, mapState } from 'vuex';
import rules from './rules.vue';
import { getPlatInfo } from '@baidu/map-fe-utils';
let top = 0;
import dialogBox from '../../dialogBox/index.vue';
export default {
  props: {
    isLogin: {
      type: Number,
      default: 0
    },
    statusType: {
      type: null,
      default: null
    },
    needHistory: {
      type: Boolean,
      default: () => false
    },
    cardId: {
      default: '',
      type: String
    }
  },
  components: {
    rules,
    dialogBox
    // HelpPopup
  },

  data() {
    // 这里存放数据
    return {
      isNative: getPlatInfo().isNative
      // notice 带 btn数据
    };
  },

  computed: {},
  mounted() {
    // this.stopScroll(true); // 设置弹窗下页面不可滚动

    // if (this.needHistory) {
    //     window.history.pushState('', document.title, '#modal');
    // }
    // if (window.history && window.history.pushState) {
    //     window.addEventListener('popstate', this.noticeFatherCloseLayer, false);
    // }
  },
  methods: _objectSpread(_objectSpread({}, mapMutations(['closeDialogBox', 'setIsShow'])), {}, {
    // 关闭弹窗
    noticeFatherCloseLayer() {
      this.$emit('closeDialogBox', true);
      // this.closeDialogBox(this.dialogNum);
      // switch (this.dialogNum) {
      //     case 2:
      //     case 4:
      //         this.setIsShow(false);
      //         break;
      // }
      // setTimeout(() => {
      //     // this.stopScroll(false);
      // }, 300);
    },

    /**
     * 阻止页面滚动，用于弹窗开启
     */
    stopScroll(isFixed) {
      // const bodyEl = document.body;
      // if (isFixed) {
      //     top = window.scrollY;
      //     bodyEl.style.position = 'fixed';
      //     bodyEl.style.top = -top + 'px';
      // }
      // else {
      //     bodyEl.style.position = '';
      //     bodyEl.style.top = '';

      //     window.scrollTo(0, top); // 回到原先的top
      // }
    },
    jumpToLogin() {
      this.$emit('jointLogin');
    }
  }),
  destroyed() {
    // this.stopScroll(false);
  }
};